import { Tabs } from "@mantine/core";
import { useStyle } from "../InventoryOrders.styles";
import Transactions from "./Tabs/Transactions";

const Orders = () => {
  const { classes } = useStyle();
  return (
    <div>
      <div>
        <h1 className={classes.headerText}>Orders</h1>
      </div>

      <Tabs defaultValue="transactions">
        <Tabs.List>
          <Tabs.Tab value="transactions">Transactions</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="transactions" pt="xs">
          <Transactions />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default Orders;
